import { useQuery } from '@tanstack/react-query';
import { axiosAPI } from './axios-instance';
import { ApiResponse, ImageShape } from '@/types';
import { ArticleTag } from './tags';

export type Article = {
    id: number;
    slug: string;
    name: string;
    signature: string;
    published_at: number;
    description?: string | null;
    preview_image: ImageShape;
    tags: ArticleTag[];
};

type ApiArticlesRequest = Partial<{
    limit: number;
    page: number;
    'tags[]'?: number[];
    order: string;
    sort: string;
}>;

export type ApiArticlesResponse = ApiResponse<{
    totalCount: number;
    items: Article[];
}>;

export const getArticles = (params?: ApiArticlesRequest, signal?: AbortSignal) =>
    axiosAPI.get<ApiArticlesResponse>(`/v1/articles`, { params, signal }).then((res) => res.data);

export const useArticlesQuery = ({
    queryParams,
    initialData,
    callback,
}: {
    queryParams?: ApiArticlesRequest;
    initialData?: ApiArticlesResponse;
    callback?: () => void;
} = {}) =>
    useQuery({
        queryKey: ['articles', queryParams],
        queryFn: ({ signal }) => getArticles(queryParams, signal),
        keepPreviousData: true,
        placeholderData: initialData,
        onSettled: () => {
            callback?.();
        },
    });
